// extracted by mini-css-extract-plugin
export default {"container":"Creation_container__4hsho","midContainer":"Creation_midContainer__5r6Db"};